import React from 'react';
import { ArrowRightIcon } from 'lucide-react';
import { IMAGES, LINKS } from '../data/site';
const APPLICATIONS = ['Automotive', 'Motorcycle', 'Aircraft', 'Architectural', 'Sculptural'];
export function CustomWork() {
  return <section className="border-t border-steel-200 bg-cream" aria-labelledby="custom-heading" data-id="element-57" data-mp="1owp9sno24f14">
      <div className="mx-auto grid max-w-[1240px] gap-10 px-5 py-16 sm:px-8 lg:grid-cols-[minmax(0,1.05fr)_minmax(0,1fr)] lg:gap-16 lg:py-24" data-id="element-58" data-mp="1k08hridqlgir">
        <figure className="order-2 mx-auto w-full max-w-[580px] self-center lg:order-1" data-id="element-59" data-mp="wb61oeyr3vqd">
          <img src={IMAGES.customCoachbuilding} alt="Unpainted metal bodywork on a classic open-top car with wire wheels and whitewall tires." loading="lazy" width={1862} height={845} className="h-auto w-full object-contain" data-id="element-60" data-mp="sa42tz8qxlox" />
          <figcaption className="mt-3 border-t border-steel-200 pt-3 text-[13px] leading-snug text-steel-600" data-id="element-61" data-mp="2cnl6nz7de0f8">
            Custom coachbuilding by Fournier Enterprises.
          </figcaption>
        </figure>

        <div className="order-1 lg:order-2 lg:pt-6" data-id="element-62" data-mp="225e9c7k8fjh2">
          <p className="font-display text-[13px] uppercase tracking-eyebrow text-fred" data-id="element-63" data-mp="224374c6fqjs2">Custom fabrication</p>
          <h2 id="custom-heading" className="mt-4 font-display text-[40px] font-bold uppercase leading-[0.95] text-charcoal sm:text-[52px]" data-id="element-64" data-mp="275iptxl54e7a">
            From a single panel
            <br data-id="element-65" data-mp="1edz4o84zgq2n" />
            to a complete body.
          </h2>
          <p className="mt-5 max-w-[52ch] text-[16px] leading-relaxed text-steel-600 sm:text-[17px]" data-id="element-66" data-mp="1jfy7ngwt9kz2">
            We shape one-off and small-quantity work in aluminum and mild steel — panels, fuel tanks, hood
            scoops, fenders and full coachbuilding, built in the shop by hand and by wheel.
          </p>

          <ul className="mt-6 flex flex-wrap gap-x-6 gap-y-2 border-y border-steel-200 py-4 text-[13px] uppercase tracking-[0.12em] text-steel-600" data-id="element-67" data-mp="vp2i6qftv1uz">
            {APPLICATIONS.map(item => <li key={item} data-id="element-68" data-mp="smej17chwjd7">{item}</li>)}
          </ul>

          <p className="mt-6 max-w-[52ch] text-[15px] leading-relaxed text-steel-600" data-id="element-69" data-mp="npo5ors2s1vh">
            To get an estimate moving, tell us the material, dimensions, quantity and timing, and send any
            drawings or photos you have. The more we can see, the more useful our answer will be.
          </p>

          <div className="mt-8 flex flex-wrap items-center gap-6" data-id="element-70" data-mp="9q6b1vs3lue7">
            <a href={LINKS.contact} className="inline-flex min-h-[52px] items-center bg-charcoal px-7 font-display text-[20px] uppercase tracking-[0.06em] text-white transition-colors duration-150 ease-out hover:bg-fred" data-id="element-71" data-mp="4q1w4a6u97q3">
              Discuss Your Project
            </a>
            <a href={LINKS.fabrication} className="inline-flex min-h-[44px] items-center gap-2 text-[15px] text-charcoal underline decoration-steel-200 underline-offset-4 transition-colors duration-150 ease-out hover:decoration-fred" data-id="element-72" data-mp="1v1y9wkq0a6f5">
              See custom metal shaping
              <ArrowRightIcon aria-hidden="true" className="h-4 w-4 text-fred" data-id="element-73" data-mp="22n0gz3r5df02" />
            </a>
          </div>
        </div>
      </div>
    </section>;
}